export default "__VITE_ASSET__RWhgYSTZ__"